export const buildData = (Triviadata, id, version) => {
    const resourceObject = Triviadata.filter(obj => obj.resourceid === id);
    const object = resourceObject.filter(obj => obj.versionNumber === version);
    let dataToSend = object[0];
    dataToSend.isdeleted = 1;
    return dataToSend;
};

export const handleError = (response) => {
    if(response.data.status === 1){
        return "Resource is successfully Requested to delete.";
    } else {
        return "There is a problem deleting resource. Please try again.";
    }
}

